import { ConfigProvider, Select, theme } from "antd"
import React, { useEffect, useState } from "react"

const cityList = [
    { value: "shiraz", label: "شیراز" },
    { value: "tabriz", label: "تبریز" },
    { value: "tehran", label: "تهران" },
    { value: "yazd", label: "یزد" },
    { value: "gorgan", label: "گرگان" },
    { value: "kerman", label: "کرمان" },
    { value: "esfahan", label: "اصفهان" },
    { value: "mashhad", label: "مشهد" },
    { value: "zanjan", label: "زنجان" },
    { value: "ahvaz", label: "اهواز" },
    { value: "baolsar", label: "بابلسر" },
    { value: "ramsar", label: "رامسر" },
    { value: "karaj", label: "کرج" },
    { value: "sorkhrud", label: "سرخرود" },
    { value: "noshahr", label: "نوشهر" },
    { value: "arak", label: "اراک" },
]

const TempCityNameSelect = ({ selectedTextObj, updateSelectedText }) => {
    const [value, setValue] = useState("tehran")

    useEffect(() => {
        setValue(selectedTextObj?.options?.cityname || "tehran")
    }, [selectedTextObj])

    if (selectedTextObj?.variable?.key !== "temp") return

    return (
        <div className="control-section">
            <h3>شهر را انتخاب کنید: </h3>
            <div className="style-control">
                <label>اسم شهر: </label>
                <ConfigProvider theme={{ algorithm: theme.darkAlgorithm }}>
                    <Select
                        value={value}
                        style={{ width: 120 }}
                        options={cityList}
                        onChange={(value) => {
                            setValue(value)
                            updateSelectedText("options", {
                                ...selectedTextObj.options,
                                cityname: value,
                            })
                        }}
                    />
                </ConfigProvider>
            </div>
        </div>
    )
}

export default TempCityNameSelect
